import { configureStore } from "@reduxjs/toolkit";
import eyeExamReducer from "./eyeExamSlice";

export const store = configureStore({
  reducer: {
    eyeExam: eyeExamReducer,
  },
});
